'use strict';

var _regeneratorRuntime = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var varint = require('varint');

var dagCbor = require('@ipld/dag-cbor');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var varint__default = /*#__PURE__*/_interopDefaultLegacy(varint);

function createHeader(roots) {
  var headerBytes = dagCbor.encode({
    version: 1,
    roots: roots
  });
  var varintBytes = varint__default["default"].encode(headerBytes.length);
  var header = new Uint8Array(varintBytes.length + headerBytes.length);
  header.set(varintBytes, 0);
  header.set(headerBytes, varintBytes.length);
  return header;
}

function createEncoder(writer) {
  return {
    setRoots: function setRoots(roots) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var bytes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bytes = createHeader(roots);
                _context.next = 3;
                return writer.write(bytes);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    writeBlock: function writeBlock(block) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var cid, bytes;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cid = block.cid, bytes = block.bytes;
                _context2.next = 3;
                return writer.write(new Uint8Array(varint__default["default"].encode(cid.bytes.length + bytes.length)));

              case 3:
                _context2.next = 5;
                return writer.write(cid.bytes);

              case 5:
                if (!bytes.length) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 8;
                return writer.write(bytes);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    close: function close() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", writer.end());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
}

exports.createEncoder = createEncoder;
exports.createHeader = createHeader;